export enum NextStepDeciderType {
  Expression = 1,
  Simple = 2
}
